import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Icon from "../../Icon";
import LanguageSelectItem from "./LanguageSelectItem";
import styles from "./LanguageBar.module.scss";
import withTheme from "../../../libs/themr/withTheme";

const LanguageBar = ({ theme, languages, handleChange, selected, className }) => {
  const current = languages.find(l => l.name === selected);
  const [languageSelectVisible, setLanguageSelectVisible] = useState(false);

  const toggleLanguageSelect = useCallback(() => {
    if (languages.length > 1) {
      setLanguageSelectVisible(!languageSelectVisible);
    }
  }, [languageSelectVisible, languages]);

  const handleDocumentClick = useCallback(() => {
    if (languageSelectVisible) {
      setLanguageSelectVisible(false);
    }
  }, [languageSelectVisible]);

  useEffect(() => {
    if (document) {
      document.addEventListener("click", handleDocumentClick);
    }

    return () => {
      if (document) {
        document.removeEventListener("click", handleDocumentClick);
      }
    };
  }, [handleDocumentClick]);

  return (
    <div className={cx(theme.languageBar, className)}>
      <button type="button" onClick={toggleLanguageSelect} className={theme.languageSelectBtn}>
        <Icon className={theme.languageIcon} icon="language-bar-icon" />
        <span className={theme.languageName}>{current.name}</span>
        {languages.length > 1 && <Icon className={theme.icon} icon="drop-down-arrow" />}
      </button>
      {languages.length > 1 && (
        <>
          <ul className={cx([theme.languageDropdown, { [theme.show]: languageSelectVisible }])}>
            {languages.map(l => {
              const isSelected = selected === l.name;
              return (
                <LanguageSelectItem
                  theme={theme}
                  key={l.name}
                  language={l}
                  isSelected={isSelected}
                  handleClick={handleChange}
                />
              );
            })}
          </ul>
        </>
      )}
    </div>
  );
};

LanguageBar.propTypes = {
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      displayName: PropTypes.string.isRequired
    })
  ).isRequired,
  selected: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  theme: PropTypes.object.isRequired
};

LanguageBar.defaultProps = {
  className: ""
};

export default withTheme(styles)(LanguageBar);
